<script>
import {notificationMethods, reportMethods, personMethods} from "@/state/helpers";
import api from "@/helpers/axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Gecikmiş Ödemeler Raporu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
  },
  data() {
    return {
      sites: [],
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      title: "Gecİkmİş Ödemeler Raporu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Raporlar",
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 25, 50, 100],
      filter: {
        page: 1,
        limit: 50,
        delayMonth:1,
        thh:null,
        warning:null,
        execute:null,
        site:null,
      },
      filterOn: [],
      sortBy: "_id.contractDate",
      sortDesc: false,
      fields: [
        {
          key: "site",
          label: "Site",
          sortable: true,
        },
        {
          key: "name",
          label: "Müşteri",
          sortable: true,
        },
        {
          key: "phone1",
          label: "Telefon",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "amount",
          label: "Geciken Tutar",
          sortable: false,
        },
        {
          key: "payments",
          label: "Geciken Taksit Sayısı",
          sortable: false,
        },
      ],
      pageInputCurrentPage:1,
      columns: [
        {
          field: "site",
          label: "Site",
        },
        {
          field: "name",
          label: "Müşteri",
        },
        {
          field: "phone1",
          label: "Telefon",
        },
        {
          field: "email",
          label: "Email",
        },
        {
          field: "amount",
          label: "Geciken Tutar",
        },
      ],
  };
  },
  validations: {
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
    filteredSites() {
      return this.sites.filter(site => site.field === true);
    },
  },
  watch: {
    page(newPage) {
      this.pageInputCurrentPage=newPage;
      this.getLmsUsers(newPage);
    },
    totalRows(newTotalRows) {
      this.totalPages = Math.ceil(newTotalRows / this.perPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getLmsUsers();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.addForm.email.toLowerCase()
    },
    'editForm.email': function () {
      this.editForm.email = this.editForm.email.toLowerCase()
    }
  },
  mounted() {
    this.getSalesReport(1);
    this.fetchSites();
  },
  methods: {
    ...personMethods,
    ...reportMethods,
    ...notificationMethods,
    badgeClass(item) {
      if (item.execute) {
        return 'badge-soft-primary';
      } else if (item.warning) {
        return 'badge-soft-yellow';
      } else if (item.thh) {
        return 'badge-soft-warning';
      } else if (item.completedStatus) {
        return 'badge-soft-info';
      } else if (!item.status) {
        return 'badge-soft-danger';
      } else if (item.status) {
        return 'badge-soft-success';
      } else {
        return 'badge-soft-light'; // Eğer hiçbir duruma uymuyorsa boş bir sınıf döner
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getSalesReport(page = this.page) {
      this.itemsLoaded = false;
      this.filter.page = page;
      this.filter.limit = this.perPage;

      this.fetchDelayedInstallmentReport(this.filter).then((res) => {
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.filter((elem) => elem.contractId);
        this.itemsLoaded = true;
        this.onFiltered(res)

      });
    },

    navigateToCustomer(item){
      let customerId = item.customerId;
      window.open(`/customers/${customerId}`, '_blank');
    },
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    },
    async fetchSites( ) {
      try {
        const response = await api.get("/sites" );
        this.sites = response.data.data.docs;
      } catch (error) {
        return
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <form>
                <div class="row align-items-center">
                  <div class="col-3">
                    <div class="form-group mb-0">
                      <label for="site">Site Seçiniz</label>
                      <select id="site" v-model="filter.site" class="form-control">
                        <option value="">Site Seçiniz</option>
                        <option v-for="site in this.sites" :key="site.id" :value="site.id">{{ site.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group mb-0">
                      <label>Gecikme Süresi</label>
                      <select name="delayMonth"
                              id="delayMonth"
                              v-model="filter.delayMonth"
                              class="form-control">
                        <option value="1">1 Ay</option>
                        <option value="2">2 Ay</option>
                        <option value="3">3 Ay</option>
                        <option value="4">4 Ay</option>
                        <option value="5">5 Ay</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-2">
                    <div class="form-group">
                      <label>Tüketici Hakem Heyeti</label>
                      <select name="thh"
                              id="thh"
                              v-model="filter.thh"
                              class="form-control">
                        <option :value=null>Thh Durumu</option>
                        <option :value="true">Evet</option>
                        <option :value="false">Hayır</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-2">
                    <div class="form-group">
                      <label for="warning">İhtar Durumu</label>
                      <select name="warning"
                              v-model="filter.warning"
                              class="form-control">
                        <option :value=null>İhtar Durumu</option>
                        <option :value="true">Evet</option>
                        <option :value="false">Hayır</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="form-group">
                      <label for="execute">İcra Durumu</label>
                      <select name="execute"
                              v-model="filter.execute"
                              class="form-control">
                        <option :value=null>İcra Durumu</option>
                        <option :value="true">Evet</option>
                        <option :value="false">Hayır</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-2 align-self-end">
                    <div>
                      <button @click="getSalesReport()" type="button" class="btn btn-primary w-md">
                        Listele
                      </button>
                    </div>
                  </div>
                  <div class="col-2 align-self-end" v-if="items.length>0">
                    <vue-excel-xlsx
                        type="button"
                        class="btn btn-outline-dark mt-3"
                        :data="items"
                        :columns="columns"
                        :file-name="'Gecikmiş Ödemeler'"
                        :file-type="'xlsx'"
                        :sheet-name="'sheetname'"
                    >
                      Excel halini indir
                    </vue-excel-xlsx>
                  </div>
                </div>
              </form>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"

              >
                <template v-slot:cell(name)="data">
                  <p @click="navigateToCustomer(data.item)" :style="{cursor:'pointer'}">
                    <span v-if="data.item.contractId"
                          class="badge badge-pill font-size-14"
                          :class="badgeClass(data.item)">
                      {{data.item.name}}
                    </span>

                    </p>
                </template>
                <template v-slot:cell(amount)="data">
                  {{moneyFormat(data.item.amount)}}
                </template>"
                <template v-slot:cell(payments)="data">
                  {{data.item.payments.length}}
                </template>"
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'40px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}" @keyup.enter="currentPage=pageInputCurrentPage" v-model="pageInputCurrentPage" type="text"  class="form-control">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
<!--                <div class="page-info mt-2" v-if="filteredItems.length"> Toplam sayfa sayısı {{  totalPages }}</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
.badge-soft-yellow {
  color: #000000;
  background-color: rgba(255, 255, 0, 0.85); }
</style>
